import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "col no-padding"
}
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "col drugAddition q-mb-md" }
const _hoisted_6 = { class: "col firstParagraph q-mb-md" }
const _hoisted_7 = {
  key: 1,
  class: "col no-padding"
}
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "col drugAddition q-mb-md" }
const _hoisted_10 = { class: "col firstParagraph q-mb-md" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MedList = _resolveComponent("MedList")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (!_ctx.hideElements)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.perfusionWay === 'behal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('Infusion.InContainer.Title')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Infusion.InContainer.Text')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.perfusionWay === 'leit')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Infusion.InLine.Title')), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('Infusion.InLine.Text')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_MedList, {
      tabOfSelectedMeds: _ctx.tabOfSelectedMeds,
      updateSelectedMeds: _ctx.updateSelectedMeds,
      transport: _ctx.transport,
      perfusionWay: _ctx.perfusionWay
    }, null, 8, ["tabOfSelectedMeds", "updateSelectedMeds", "transport", "perfusionWay"]),
    _hoisted_11
  ]))
}